import { useState } from 'react'
import Modal from '@components/Modal'
import Icon from '@components/Icon'
import styles from './styles.module.scss'

const InfoPopup = ({ iconClassName, className, title, content }) => {
    const [showPopup, setShowPopup] = useState(false)

    const openPopup = () => setShowPopup(true)

    const closePopup = () => setShowPopup(false)

    return (
        <>
            {showPopup && (
                <Modal
                    header={title}
                    onClose={closePopup}
                    className={styles.infoModal}
                    buttons={[
                        {
                            btnStyle: 'outline',
                            onClick: closePopup,
                            label: <T>info.popup.button.ok</T>,
                            btnClassName: 'ml-auto',
                        },
                    ]}>
                    <p className="text-left">{content}</p>
                </Modal>
            )}
            <span onClick={openPopup} className={className}>
                <Icon className={iconClassName} type="info" size="xxs" />
            </span>
        </>
    )
}

export default InfoPopup
